import React from "react";
export default function IFS() {
  return <div>Excel_IFS</div>;
}
